<template>
    <div class="container">
        <el-card class="form">
            <el-form
                ref="form"
                label-position="right"
                :rules="rules"
                label-width="100px"
                :model="form"
            >
                <el-form-item label="化合物定制" prop="title">
                    <el-input v-model="form.title" placeholder="请输入化合物定制"></el-input>
                </el-form-item>
                <el-form-item label="CAS" prop="casCode">
                    <el-input v-model="form.casCode" placeholder="请输入CAS"></el-input>
                </el-form-item>
                <el-form-item label="需求量" prop="required">
                    <el-input v-model="form.required" placeholder="请输入需求量"></el-input>
                </el-form-item>
                <el-form-item label="纯度" prop="purity">
                    <el-input v-model="form.purity" placeholder="请输入纯度"></el-input>
                </el-form-item>
                <el-form-item label="期望交货期" prop="deliveryTime">
                    <el-date-picker
                        style="width: 100%;"
                        v-model="form.deliveryTime"
                        type="date"
                        placeholder="选择日期"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item ref="structure" label="产品结构图" prop="uploadStructureFile">
                    <el-upload action :before-upload="uploadStructure">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                    <div>{{ form.uploadStructureFile.name }}</div>
                </el-form-item>
                <el-form-item ref="literatrue" label="文献资料" prop="uploadLiteratureFile">
                    <el-upload action :before-upload="uploadLiterature">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                    <div>{{ form.uploadLiteratureFile.name }}</div>
                </el-form-item>
                <el-form-item label="姓名" prop="userName">
                    <el-input v-model="form.userName" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="Emaill" prop="userEmail">
                    <el-input v-model="form.userEmail" placeholder="请输入Emaill"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="userMobile">
                    <el-input v-model="form.userMobile" placeholder="请输入手机号码"></el-input>
                </el-form-item>
                <el-form-item label="单位名称" prop="company">
                    <el-input v-model="form.company" placeholder="请输入单位名称"></el-input>
                </el-form-item>
                <el-form-item label="特殊说明" prop="specialNotes">
                    <el-input v-model="form.specialNotes" placeholder="请输入特殊说明"></el-input>
                </el-form-item>
            </el-form>
            <el-button class="btn" type="success" @click="onSubmitValidate()">提交</el-button>
        </el-card>
        <Hot></Hot>
    </div>
</template>

<script>
import Hot from '../components/hot/Hot';
import * as apis from '../fetch/common';
import { format } from 'date-fns';

export default {
    name: 'promade',
    components: {
        Hot,
    },
    data() {
        return {
            form: {
                title: '',
                casCode: '',
                required: '',
                purity: '',
                deliveryTime: '',
                uploadStructureFile: '',
                uploadLiteratureFile: '',
                userName: '',
                userEmail: '',
                userMobile: '',
                company: '',
                specialNotes: '',
            },
            rules: {
                purity: [{ required: true, message: '请输入纯度' }],
                title: [{ required: true, message: '请输入化合物定制' }],
                uploadLiteratureFile: [{ required: true, message: '请选择文献资料' }],
                uploadStructureFile: [{ required: true, message: '请选择产品结构图' }],
            },
        };
    },
    methods: {
        uploadStructure(file) {
            this.form.uploadStructureFile = file;
            this.$refs['structure'].validate();
            return false;
        },
        uploadLiterature(file) {
            this.form.uploadLiteratureFile = file;
            this.$refs['literatrue'].validate();
            return false;
        },
        onSubmitValidate() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.onSubmit();
                } else {
                    return false;
                }
            });
        },
        onSubmit() {
            const params = { ...this.form };
            if (params.deliveryTime) {
                params.deliveryTime = format(params.deliveryTime, 'yyyy-MM-dd');
            }
            apis.saveProMade(params).then(res => {
                this.$message.success('定制成功');
            });
        },
    },
};
</script>

<style lang="less" scoped>
.container {
    display: flex;
    justify-content: space-between;
}

.form {
    width: 895px;
    height: max-content;
    .btn {
        margin-left: 100px;
    }
}
</style>
